import { loginRequest } from "../../services/auth.services";

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT = "LOGOUT";
export const DEVICE_TOKEN = "DEVICE_TOKEN";



export const loginUserAction = (data, history, setLoading, setError) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      let result = await loginRequest(data);
      if (result.data?.isAdmin) {
        history.push("/home");
      } else {
        history.push("/selectteam");
      }

      dispatch({
        type: LOGIN_USER_SUCCESS,
        payload: result.data,
      });
    } catch (e) {
      setError(e);
      console.log("error at loginnnn", e);
    } finally {
      setLoading(false);
    }
  };
};
